import React from 'react'
import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  communityBox: {
    fontFamily: "'Dosis', sans-serif",
    backgroundColor: '#FFFFBA',
    position: 'relative',
    zIndex: 11,
    padding: '16px',
    borderRadius: '8px',
    '& .communityButton': {
      width: '100%',
      display: 'inline-block',
      fontSize: '0px',
      padding: '8px 8px',
      position: 'relative',
      '& img': {
        width: '100%',
      },
    },
    '& .medium': {
      backgroundColor: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      '& img': {
        width: '48px !important',
      },
      '& span': {},
    },
  },
  [theme.breakpoints.up('sm')]: {
    communityBox: {
      padding: '16px',
      '& .communityButton': {
        width: '50%',
        display: 'inline-block',
        fontSize: '0px',
        padding: '8px 8px',
        position: 'relative',
        '& img': {
          width: '100%',
        },
      },
      '& .medium': {
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        '& img': {
          width: '48px !important',
        },
        '& span': {},
      },
    },
  },
}))

const CommunityBox = () => {
  const classes = useStyles()

  return (
    <Box className={classes.communityBox}>
      <a className="communityButton" href="https://twitter.com/samoyedfinance" rel="noreferrer" target="_blank">
        <img src="/images/twitter-button.png" alt="twitter" />
      </a>
      <a className="communityButton" href="https://t.me/samoyedfinance" rel="noreferrer" target="_blank">
        <img src="/images/telegram-button.png" alt="telegram" />
      </a>
      <a className="communityButton" href="https://medium.samoyedfinance.app/" rel="noreferrer" target="_blank">
        <img style={{ borderRadius: '16px' }} src="/images/medium-button.png" alt="medium" />
      </a>
      <a
        className="communityButton"
        href="https://www.youtube.com/channel/UCVbrDYiG2I8yRIPnwScH59g"
        rel="noreferrer"
        target="_blank"
      >
        <img src="/images/youtube-button.png" alt="youtube" />
      </a>
    </Box>
  )
}

export default CommunityBox
